/* unplugin-vue-components disabled */import { render } from "./source-sup.vue?vue&type=template&id=c6fb863a&scoped=true"
import script from "./source-sup.vue?vue&type=script&lang=js"
export * from "./source-sup.vue?vue&type=script&lang=js"

import "./source-sup.vue?vue&type=style&index=0&id=c6fb863a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6fb863a"],['__file',"src/components/sources/source-sup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c6fb863a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c6fb863a', __exports__)) {
    api.reload('c6fb863a', __exports__)
  }
  
  module.hot.accept("./source-sup.vue?vue&type=template&id=c6fb863a&scoped=true", () => {
    api.rerender('c6fb863a', render)
  })

}


export default __exports__